<template>
  <div class="custom-checkbox-group">
    <label
      v-if="label"
      class="custom-checkbox-group__label"
      v-bind="$attrs"
    >
      {{ label }}
    </label>

    <div class="custom-checkbox-group__form" :class="classList">
      <label v-for="(option, index) in value" :key="index">
        <input
          type="checkbox"
          :disabled="option[disabledKey]"
          :checked="option[checkedKey || 'checked']"
          @change="toggle(index)"
        />
        <slot v-bind="{ ...option, index }"></slot>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomCheckboxGroup',

  props: {
    value: {
      type: Array,
      required: true
    },
    label: String,
    labelKey: String,
    checkedKey: {
      type: String,
      default: 'checked'
    },
    disabledKey: String,
    classList: [String, Array, Object]
  },

  methods: {
    toggle(index) {
      const key = this.checkedKey || 'checked'
      const newValue = this.value.map((item, i) => {
        if (i === index) {
          return { ...item, [key]: !item[key] }
        }
        return { ...item }
      })
      this.$emit('input', newValue)
    }
  }
}
</script>

<style lang="scss">
.custom-checkbox-group {
  &__label {
    color: var(--attendee-text-secondary-color);
    font-size: 16px;
    gap: var(--attendee-gap-sm);
    font-weight: 400;
  }

  &__form {
    display: flex;
    flex-wrap: wrap;
    gap: var(--attendee-gap-xs);

    label {
      cursor: pointer;
    }
  }

  input {
    visibility: hidden;
    width: 0;
    height: 0;
    overflow: hidden;
    position: absolute;
  }
}
</style>